export default __webpack_public_path__ + "static/media/digitick.93bfa0b9.png";